var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRupeesYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1910_34472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.52605 27.2535C8.15782 27.4379 6.88597 26.5186 6.63942 25.1671L6.33619 23.5049C6.24929 23.0286 5.94907 22.6175 5.52052 22.3881L4.02518 21.5875C2.80933 20.9366 2.32352 19.4492 2.92258 18.2117L3.65935 16.6896C3.8705 16.2534 3.8705 15.7453 3.65935 15.3091L2.92258 13.7871C2.32352 12.5495 2.80933 11.0621 4.02518 10.4112L5.52052 9.61065C5.94907 9.38123 6.24929 8.97015 6.33619 8.49379L6.63942 6.83162C6.88597 5.48012 8.15782 4.56085 9.52605 4.74521L11.2088 4.97196C11.6911 5.03694 12.1768 4.87992 12.5286 4.54535L13.756 3.37794C14.754 2.42872 16.3261 2.42872 17.3241 3.37794L18.5515 4.54535C18.9032 4.87992 19.389 5.03694 19.8712 4.97196L21.554 4.74521C22.9222 4.56085 24.1941 5.48012 24.4406 6.83162L24.4688 6.98617C24.7295 8.41526 25.6302 9.64847 26.9158 10.3368L27.0549 10.4112C28.2707 11.0621 28.7565 12.5495 28.1575 13.7871L27.4207 15.3091C27.2095 15.7453 27.2095 16.2534 27.4207 16.6896L28.1575 18.2117C28.7565 19.4492 28.2707 20.9366 27.0549 21.5875L25.5595 22.3881C25.131 22.6175 24.8308 23.0286 24.7439 23.5049L24.4406 25.1671C24.1941 26.5186 22.9222 27.4379 21.554 27.2535L19.8712 27.0268C19.389 26.9618 18.9032 27.1188 18.5515 27.4534L17.3241 28.6208C16.3261 29.57 14.754 29.57 13.756 28.6208L12.5286 27.4534C12.1768 27.1188 11.6911 26.9618 11.2088 27.0268L9.52605 27.2535Z",
    fill: "url(#paint0_linear_1910_34472)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9715 13.0062L20.4672 14.867L11.0425 14.867L11.5538 13.0062L20.9715 13.0062ZM16.2342 24.0005L11.2627 18.0204L11.2555 16.4437L13.7129 16.4437C14.3001 16.4437 14.7901 16.3466 15.1831 16.1525C15.5808 15.9537 15.8815 15.6767 16.0851 15.3216C16.2934 14.9617 16.3976 14.5403 16.3976 14.0574C16.3976 13.3329 16.1845 12.7505 15.7584 12.3102C15.3323 11.8699 14.6504 11.6497 13.7129 11.6497L11.0425 11.6497L11.5965 9.45508L13.7129 9.45508C14.9061 9.45508 15.8933 9.63974 16.6746 10.0091C17.4606 10.3736 18.0477 10.8897 18.4359 11.5574C18.8289 12.225 19.0254 13.0062 19.0254 13.9011C19.0254 14.6918 18.881 15.3973 18.5922 16.0176C18.3034 16.6378 17.8488 17.1468 17.2286 17.5446C16.6083 17.9423 15.7963 18.2074 14.7925 18.34L14.7073 18.3684L19.1959 23.8727L19.1959 24.0005L16.2342 24.0005ZM20.9857 9.45508L20.4672 11.3443L12.8252 11.3159L13.3436 9.45508L20.9857 9.45508Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1910_34472",
    x: 2.6665,
    y: 2.66602,
    width: 25.7471,
    height: 26.666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.33333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1910_34472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1910_34472",
    x1: 2.6665,
    y1: 5.44379,
    x2: 25.4443,
    y2: 25.4438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB42E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupeesYellow);
export default __webpack_public_path__ + "static/media/rupees_yellow.e1f9e7e252f12b00f52e0bf4e921ac64.svg";
export { ForwardRef as ReactComponent };